export default __webpack_public_path__ + "115f9979196c4fd0f958f75b69f63506.svg";